var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-header"},[_c('h2',{staticClass:"sub-header__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"sub-header__bread-crumbs"},[_c('BreadCrumbs',{attrs:{"crumbs":_vm.crumbs}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }